var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgTotalAttendees = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 16,
    viewBox: "0 0 19 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.20455 12.3182L8.93182 9.64546C8.57727 9.60909 8.31364 9.59091 8.02273 9.59091C5.59545 9.59091 0.75 10.8091 0.75 13.2273V15.0455H8.93182L6.20455 12.3182ZM8.02273 7.77273C10.0318 7.77273 11.6591 6.14545 11.6591 4.13636C11.6591 2.12727 10.0318 0.5 8.02273 0.5C6.01364 0.5 4.38636 2.12727 4.38636 4.13636C4.38636 6.14545 6.01364 7.77273 8.02273 7.77273Z",
    fill: "#588966"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0864 15.5L8.93188 12.3182L10.2046 11.0364L12.0864 12.9273L16.7501 8.22729L18.0228 9.50911L12.0864 15.5Z",
    fill: "#588966"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgTotalAttendees, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/total_attendees.9537331f.svg";
export { ForwardRef as ReactComponent };